export default {
  FIRST_STEPS: 'FIRST_STEPS',
  BANK_ACCOUNT_SELECTION: 'BANK_ACCOUNT_SELECTION',
  BATCH_FORM: 'BATCH_FORM',
  BATCHES_WAITING_FOR_BALANCE: 'BATCHES_WAITING_FOR_BALANCE'
};
